import { useState, useEffect } from 'react';
import { Rating } from '@mui/material';

const API_URL = import.meta.env.VITE_API_URL;

const getAuthToken = () => localStorage.getItem('accessToken');

export default function StarRating({ faqId }) {
  const [userScore, setUserScore] = useState(null);
  const [average, setAverage] = useState(0);
  const [count, setCount] = useState(0);
  const [saving, setSaving] = useState(false);
  const [rated, setRated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setRated(false);
    setUserScore(null);
    setAverage(0);
    setCount(0);
    Promise.all([loadRating(), loadMyRating()]).finally(() => setLoading(false));
  }, [faqId]);

  const loadRating = async () => {
    try {
      const res = await fetch(`${API_URL}/chatbot/faq/${faqId}/rating`);
      if (res.ok) {
        const data = await res.json();
        setAverage(data.average ?? 0);
        setCount(data.count ?? 0);
      }
    } catch {}
  };

  const loadMyRating = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      const res = await fetch(`${API_URL}/chatbot/faq/${faqId}/my-rating`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.ok) {
        const data = await res.json();
        if (data.score !== null && data.score !== undefined) {
          setUserScore(data.score);
          setRated(true);
        }
      }
    } catch {}
  };

  const handleRate = async (newValue) => {
    if (saving) return;
    setSaving(true);
    setUserScore(newValue);
    const token = getAuthToken();
    try {
      const res = await fetch(`${API_URL}/chatbot/faq/${faqId}/rating`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ score: newValue }),
      });
      if (res.ok) {
        setRated(true);
        loadRating();
      }
    } catch {} finally {
      setSaving(false);
    }
  };

  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (rated) {
      setConfirmed(true);
      const timer = setTimeout(() => setConfirmed(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [rated]);

  return (
    <div className="px-3 py-2 opacity-0 transition-opacity duration-200"
         style={!loading ? { opacity: 1 } : undefined}>
      <p className="text-xs text-gray-500 mb-1">
        {rated
          ? '¡Gracias por tu valoración!'
          : '¿Te fue útil esta respuesta?'}
      </p>
      <div className="flex items-center gap-2">
        <Rating
          value={rated ? userScore : average}
          precision={1}
          onChange={(_, newValue) => {
            if (newValue) handleRate(newValue);
          }}
          size="small"
          readOnly={rated}
          sx={{
            '& .MuiRating-iconFilled': { color: '#f59e0b' },
            '& .MuiRating-iconHover': { color: '#f59e0b' },
          }}
        />
        {count > 0 && !rated && (
          <span className="text-xs text-gray-400">
            {average.toFixed(1)} ({count} {count === 1 ? 'voto' : 'votos'})
          </span>
        )}
        {rated && (
          <span className="text-xs text-gray-400">
            {userScore}/5
          </span>
        )}
        {confirmed && (
          <span className="text-xs text-green-600 font-medium animate-pulse">
            ✓ Enviado
          </span>
        )}
      </div>
    </div>
  );
}
